import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";

const FooterCopyright = ({ footerLogo, spaceBottomClass, colorClass, companyName, textStyle }) => {
  // 로고 URL이 http로 시작하는지 확인하여 절대 경로인지 상대 경로인지 판단
  const logoSrc = footerLogo && footerLogo.startsWith('http') 
    ? footerLogo 
    : process.env.PUBLIC_URL + footerLogo;
    
  const currentYear = new Date().getFullYear();
  const displayCompanyName = companyName || "Flone";

  return (
    <div className={clsx("copyright", spaceBottomClass, colorClass)}>
      <div className="footer-logo">
        <Link to={process.env.PUBLIC_URL + "/"}>
          <img 
            alt={displayCompanyName} 
            src={logoSrc}
            style={{
              // maxHeight: "60px",
              maxWidth: "100%",
              objectFit: "contain",
              maxHeight: "70px"
            }}
          />
        </Link>
      </div>
      <p style={textStyle}>
        &copy; {currentYear}{" "}
        {displayCompanyName}
        <br /> All Rights Reserved
      </p>
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  companyName: PropTypes.string,
  textStyle: PropTypes.object
};

export default FooterCopyright;
